import * as React from 'react';
const { useCallback } = React;

import XConnectedServicesList from './connected-services-list.view';
import { ConnectedServicesListProps as XConnectedServicesListProps } from './connected-services-list.view';


type ConnectedServicesListProps = {} & XConnectedServicesListProps;

const ConnectedServicesList: React.SFC<ConnectedServicesListProps> = (props) => {
	const [selectedAccountID, setSelectedAccountID] = React.useState(-1);
	const handleClickAccount = useCallback((accountID: number) => () => {
		accountID !== selectedAccountID ? setSelectedAccountID(accountID) : setSelectedAccountID(-1);
	}, [selectedAccountID]);

	return (
		<XConnectedServicesList
			{...props}
			selectedAccountID={selectedAccountID}
			onClickAccount={handleClickAccount}
		/>
	);
}


export default ConnectedServicesList;
